var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"heading"},[_vm._v(_vm._s(_vm.alertDef.name))]),_c('span',{staticClass:"tag is-size-7",class:_vm.classCalc,on:{"click":function($event){return _vm.goToPage()}}},[_vm._v(_vm._s(_vm.count))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }